module.exports = __webpack_public_path__ + "static/media/icon-age.6de2ff77.svg";